









import {Component, Vue} from "vue-property-decorator";
import moment, {Moment} from "moment";
import {CostTranshipmentStore} from "@/modules/receiptsexpenses/updatecosttranshipment/store";
import locale from 'ant-design-vue/lib/date-picker/locale/vi_VN';
import 'moment/locale/vi';

@Component({
  name: "CostTranshipmentMonthPicker"
})
export default class extends Vue {
  get monthFormat() {
    return "MM/YYYY";
  }

  get locale() {
    return locale;
  }

  get defaultValue() {
    return moment().locale("vi");
  }

  created() {
    const startOffMonthCurrent = this.defaultValue.clone().startOf("month").valueOf()
    const endOffMonthCurrent = this.defaultValue.clone().endOf("month").valueOf()
    CostTranshipmentStore.updateParamsCostTranshipment({
      ...CostTranshipmentStore.params,
      fromDate: startOffMonthCurrent.valueOf(),
      toDate: endOffMonthCurrent.valueOf()
    })
    CostTranshipmentStore.listCostTranshipment(CostTranshipmentStore.params)
  }

  onChange(val: Moment) {
    if (val) {
      const startOffMonth = val.clone().startOf("month")
      const endOf = val.clone().endOf("month")
      CostTranshipmentStore.updateParamsCostTranshipment({
        ...CostTranshipmentStore.params,
        fromDate: startOffMonth.valueOf(),
        toDate: endOf.valueOf()
      })
    } else CostTranshipmentStore.updateParamsCostTranshipment({
      ...CostTranshipmentStore.params,
      fromDate: undefined,
      toDate: undefined
    })

    CostTranshipmentStore.listCostTranshipment(CostTranshipmentStore.params)
  }
}
